class ATCButton extends HTMLElement{
  constructor(){
    super()

    this.submitForm = this.querySelector('form')
  }

  connectedCallback(){
    if (this.submitForm) {
      this.submitForm.addEventListener("submit", this.submitProduct.bind(this))
    }
  }

  submitProduct(e){
    e.preventDefault()
    // The cart drawer event listener will handle the actual submission
  }
  disconnectedCallback(){}
}

customElements.define("atc-button", ATCButton)